import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { RadioOutlineLegacy } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Checkbox, Stack, Typography } from '@lyearn/ui';
import { EventSubTypeEnum } from '@/types/schema';

import { buttonRootStyles } from './styles';
import { getTypeItems } from './utils';

function SubType({
  selectedSubType,
  onChange,
  disabled,
}: {
  selectedSubType: EventSubTypeEnum;
  onChange: (subType: EventSubTypeEnum) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const items = getTypeItems({ t });

  return (
    <Stack className={cn({ 'pointer-events-none opacity-50': disabled })} justifyContent="between">
      {items.map(({ id, title, description, Icon }) => {
        const isSelected = selectedSubType === id;

        return (
          <Stack
            key={id}
            alignItems="center"
            className={cn(
              'w-full cursor-pointer border px-16 py-12',
              buttonRootStyles,
              isSelected ? 'border-focus-primary' : 'border-interactive-border',
            )}
            justifyContent="between"
            role="button"
            tabIndex={0}
            onClick={() => onChange(id)}>
            <Stack>
              <Icon
                className="mt-2 h-24 w-24 me-12"
                fillColorToken={isSelected ? 'icon-active' : 'icon-primary'}
              />
              <Stack direction="col">
                <Typography color="text-text-primary" variant="body-short-01">
                  {title}
                </Typography>
                <Typography className="mt-4" color="text-text-secondary" variant="body-short-03">
                  {description}
                </Typography>
              </Stack>
            </Stack>
            <Checkbox
              checked={isSelected}
              checkedIcon={<RadioOutlineLegacy className="h-20 w-20" fillColorToken="icon-white" />}
              variant="circle"
            />
          </Stack>
        );
      })}
    </Stack>
  );
}

export default React.memo(SubType);
